export const ESTIMATES_LIST_CONTROLS_VIEW = "roopairs_estimates_list_controls_view"
export const ESTIMATES_LIST_CONTROLS_PHASE = "roopairs_estimates_list_controls_phase"
export const ESTIMATES_LIST_CONTROLS_ACTIVE_TAB = "roopairs_estimates_list_controls_active_tab"
export const ESTIMATES_LIST_CONTROLS_KEYWORD_SEARCH = "roopairs_estimates_list_controls_keyword_search"

export const JOBS_LIST_CONTROLS_VIEW = "roopairs_jobs_list_controls_view"
export const JOBS_LIST_CONTROLS_PHASE = "roopairs_jobs_list_controls_phase"
export const JOBS_LIST_CONTROLS_ACTIVE_TAB = "roopairs_jobs_list_controls_active_tab"
export const JOBS_LIST_CONTROLS_KEYWORD_SEARCH = "roopairs_jobs_list_controls_keyword_search"
export const JOBS_LIST_TIMELINE_VIEW_END_DATE_KEY = "roopairs_jobs_list_timeline_view_end_date"
export const JOBS_LIST_TIMELINE_VIEW_VISIBLE_DATE_RANGE_KEY = "roopairs_jobs_list_timeline_view_visible_date"
export const JOBS_LIST_TIMELINE_VIEW_TECHNICIANS_COLUMN_STATUS_KEY =
    "roopairs_jobs_list_timeline_view_technicians_column_status"
export const JOBS_LIST_TIMELINE_VIEW_UNSCHEDULED_JOBS_COLUMN_STATUS_KEY =
    "roopairs_jobs_list_timeline_view_unscheduled_column_status"
export const JOBS_LIST_TIMELINE_VIEW_UNSCHEDULED_JOBS_COLUMN_MESSAGE_STATUS_KEY =
    "roopairs_jobs_list_timeline_view_unscheduled_column_message_status"
export const JOBS_LIST_TIMELINE_VIEW_CARD_STYLE = "roopairs_jobs_list_timeline_view_card_style"
export const JOBS_LIST_TIMELINE_VIEW_SHOULD_SHOW_CANCELLED_JOBS =
    "roopairs_jobs_list_timeline_view_should_show_cancelled_jobs"
export const JOBS_LIST_TIMELINE_VIEW_SHOULD_SHOW_FINALIZED_JOBS =
    "roopairs_jobs_list_timeline_view_should_show_finalized_jobs"
export const JOBS_LIST_TIMELINE_VIEW_ORIENTATION = "roopairs_jobs_list_timeline_view_orientation"
export const JOBS_LIST_TIMELINE_VIEW_SCHEDULER_ZOOM_LEVELS = "roopairs_jobs_list_timeline_view_scheduler_zoom_levels"
export const JOBS_LIST_TIMELINE_VIEW_SCHEDULER_ZOOM_DAY = "roopairs_jobs_list_timeline_view_scheduler_zoom_day"
export const JOBS_LIST_TIMELINE_VIEW_SCHEDULER_ZOOM_THREE_DAYS =
    "roopairs_jobs_list_timeline_view_scheduler_zoom_three_days"
export const JOBS_LIST_TIMELINE_VIEW_SCHEDULER_ZOOM_WEEK = "roopairs_jobs_list_timeline_view_scheduler_zoom_week"
export const JOBS_LIST_TIMELINE_VIEW_SCHEDULER_ZOOM_MONTH = "roopairs_jobs_list_timeline_view_scheduler_zoom_month"
export const JOBS_LIST_TIMELINE_VIEW_TIME_FRAME_TYPE = "roopairs_jobs_list_timeline_view_time_frame_type"
export const JOBS_LIST_TIMELINE_VIEW_SHOULD_SHOW_WEEKENDS = "roopairs_jobs_list_timeline_view_should_show_weekends"

export const INVOICES_LIST_CONTROLS_VIEW = "roopairs_invoices_list_controls_view"
export const INVOICES_LIST_CONTROLS_PHASE = "roopairs_invoices_list_controls_phase"
export const INVOICES_LIST_CONTROLS_ACTIVE_TAB = "roopairs_invoices_list_controls_active_tab"
export const INVOICES_LIST_CONTROLS_KEYWORD_SEARCH = "roopairs_invoices_list_controls_keyword_search"

export const PURCHASE_ORDERS_LIST_CONTROLS_VIEW = "roopairs_purchase_orders_list_controls_view"
export const PURCHASE_ORDERS_LIST_CONTROLS_PHASE = "roopairs_purchase_orders_list_controls_phase"
export const PURCHASE_ORDERS_LIST_CONTROLS_ACTIVE_TAB = "roopairs_purchase_orders_list_controls_active_tab"
export const PURCHASE_ORDERS_LIST_CONTROLS_KEYWORD_SEARCH = "roopairs_purchase_orders_list_controls_keyword_search"

export const BILLS_LIST_CONTROLS_VIEW = "roopairs_bills_list_controls_view"
export const BILLS_LIST_CONTROLS_PHASE = "roopairs_bills_list_controls_phase"
export const BILLS_LIST_CONTROLS_ACTIVE_TAB = "roopairs_bills_list_controls_active_tab"
export const BILLS_LIST_CONTROLS_KEYWORD_SEARCH = "roopairs_bills_list_controls_keyword_search"

export const CREDIT_NOTES_LIST_CONTROLS_VIEW = "roopairs_credit_notes_list_controls_view"
export const CREDIT_NOTES_LIST_CONTROLS_PHASE = "roopairs_credit_notes_list_controls_phase"
export const CREDIT_NOTES_LIST_CONTROLS_ACTIVE_TAB = "roopairs_credit_notes_list_controls_active_tab"
export const CREDIT_NOTES_LIST_CONTROLS_KEYWORD_SEARCH = "roopairs_credit_notes_list_controls_keyword_search"

export const CLIENTS_LIST_CONTROLS_VIEW = "roopairs_clients_list_controls_view"
export const CLIENTS_LIST_CONTROLS_PHASE = "roopairs_clients_list_controls_phase"
export const CLIENTS_LIST_CONTROLS_ACTIVE_TAB = "roopairs_clients_list_controls_active_tab"
export const CLIENTS_LIST_CONTROLS_KEYWORD_SEARCH = "roopairs_clients_list_controls_keyword_search"

export const PRICEBOOK_LIST_CONTROLS_VIEW = "roopairs_pricebook_list_{type}_controls_view"
export const PRICEBOOK_LIST_CONTROLS_PHASE = "roopairs_pricebook_list_{type}_controls_phase"
export const PRICEBOOK_LIST_CONTROLS_ACTIVE_TAB = "roopairs_pricebook_list_{type}_controls_active_tab"
export const PRICEBOOK_LIST_CONTROLS_KEYWORD_SEARCH = "roopairs_pricebook_list_{type}_controls_keyword_search"

export const VENDORS_LIST_CONTROLS_VIEW = "roopairs_vendors_list_controls_view"
export const VENDORS_LIST_CONTROLS_PHASE = "roopairs_vendors_list_controls_phase"
export const VENDORS_LIST_CONTROLS_ACTIVE_TAB = "roopairs_vendors_list_controls_active_tab"
export const VENDORS_LIST_CONTROLS_KEYWORD_SEARCH = "roopairs_vendors_list_controls_keyword_search"

export const CATALOG_ITEMS_LIST_CONTROLS_VIEW = "roopairs_catalog_items_list_{brand}_controls_view"
export const CATALOG_ITEMS_LIST_CONTROLS_PHASE = "roopairs_catalog_items_list_{brand}_controls_phase"
export const CATALOG_ITEMS_LIST_CONTROLS_ACTIVE_TAB = "roopairs_catalog_items_list_{brand}_controls_active_tab"
export const CATALOG_ITEMS_LIST_CONTROLS_KEYWORD_SEARCH = "roopairs_catalog_items_list_{brand}_controls_keyword_search"

export const JOBS_SERIES_LIST_CONTROLS_VIEW = "roopairs_jobs_series_list_controls_view"
export const JOBS_SERIES_LIST_CONTROLS_PHASE = "roopairs_jobs_series_list_controls_phase"
export const JOBS_SERIES_LIST_CONTROLS_ACTIVE_TAB = "roopairs_jobs_series_list_controls_active_tab"
export const JOBS_SERIES_LIST_CONTROLS_KEYWORD_SEARCH = "roopairs_jobs_series_list_controls_keyword_search"

export const JOB_SERIES_JOBS_TABLE_VIEW = "roopairs_job_series_jobs_table_view"
export const JOB_SERIES_JOBS_TABLE_PHASE = "roopairs_job_series_jobs_table_phase"
export const JOB_SERIES_JOBS_TABLE_ACTIVE_TAB = "roopairs_job_series_jobs_table_active_tab"
export const JOB_SERIES_JOBS_TABLE_KEYWORD_SEARCH = "roopairs_job_series_jobs_table_keyword_search"

export const GLOBAL_TOAST_QUEUE = "roopairs_toast_queue"

export const SETTINGS_PREVIOUS_PAGE = "roopairs_settings_previous_page"

export const ACCOUNT_VERIFICATION_TEMPORARY_CODE_ID_HOLD = "roopairs_account_verification_temporary_code_id_hold"

export const AUTHENTICATION_METHOD_PREFERENCE = "roopairs_authentication_method_preference"

export const OBJECTS_CURRENT_VIEW_TYPE = "roopairs_objects_current_view_type"

export const CROSS_TAB_SESSION_ACTIVE = "roopairs_cross_tab_session_active"
export const COLLABORATION_USER_COLORS = "roopairs_collaboration_user_colors"

export const TIP_DISMISSED_AVATAR_VISIBILITY_FYI = "roopairs_tip_dismissed_avatar_visibility_fyi"
export const TIP_DISMISSED_JOB_SERIES_SERVICE_LOCATION = "roopairs_tip_dismissed_job_series_service_location"
export const TIP_DISMISSED_JOB_SERIES_BILLING_INTENTION = "roopairs_tip_dismissed_job_series_billing_intention"
